<template>
	<div style="width: 100%;height: 100%;background: linear-gradient(180deg, rgba(51, 51, 51, 1) 50%, rgba(5, 5, 5, 1) 100%);"
		v-if="ifSignal">
	</div>
	<div v-else style="width: 100%;height: 100%;position: relative;" id="flv264Dom">
		<div v-if="ifPlayStop" style="display: flex;width: 100%;height: 100%;align-items: center;justify-content: center;background-color: black;position: absolute;z-index: 3;">
			<img :src="playStopImg" style="width: 40%;z-index: 9;" alt="">
		</div>
		<div v-show="isM3u8 && !ifRtc" ref="m3u8PlayerRef" 
			style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;z-index: 2;"></div>
		<iframe v-show="!isM3u8 && !ifRtc" ref="flvIframe" :src="flvPlayerSrc" width="100%" height="100%"
			style="position: absolute;top: 0;left: 0;width: 99%;height: 99%;z-index: 2;" allowfullscreen></iframe>
		<div 
      v-show="ifRtc" 
      ref="playerRef" 
      v-loading="ifWaiting" 
      :element-loading-text="languageJson.videoLoading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;z-index: 2;"
    ></div>
	</div>
</template>

<script>
	import flvjs from 'flv.js'
	import { QNRTPlayer } from "qn-rtplayer-web";
	import Hls from 'hls.js'
	import videojs from 'video.js'
	import 'video.js/dist/video-js.css'
	import { getWebrtcPlay } from '@/api/indexV2'
	
const ICE_CONFIG = {
  iceServers: [
    { urls: 'stun:stun.l.google.com:19302' },
    { urls: 'turn:189.18.10.150:5349', username: 'keanke', credential: 'keanke@123' }
  ]
};
	const languageJson = window.languageJson || { videoLoading: '加载中...' }
	const config = window.config || {}

	export default {
		data() {
			return {
				peerConnection: null,
				webrtcVideoElement: null,
				languageJson: languageJson,
				oldSocket: { videoStatus: '20' },
				flvPlayer: null,
				flvPlayerSrc: '',
				ifSignal: true,
				ifRtc: false,
				isM3u8: false,
				playerRtc: null,
				videoPlayer: null,
				hlsPlayer: null,
				rtcTimer: null,
				ifWaiting: true,
				setTimeFlv: null,
				setTimeNum: 0,
				ifPlayStop: false,
				playStopImg: require('../../static/imgV2/playStop.png'),
				flvUrl: "",
				playAudoStatus: "play",
				nextInitialNO: "",
				countTime: 600,
				webrtcTimeoutTimer: null,
				// ========== 【核心新增】防重复执行锁 + 连接状态标记 ==========
				isWebRTCStarting: false,
				isWebRTCConnected: false
			}
		},
		props: ['rtmpSrc', 'initialNO', 'autoHeight', 'playType', 'vSocketData', 'rid', 'ststus', 'playStatus', 'playAudo', 'private','isStart'],
		mounted() {},
		methods: {
			// ========== 【修复】原生WebRTC：加锁、防重复、优化重连 ==========
			async startWebRTC(url) {
				if(!this.isStart)  return false
				const that = this;
				
				// 【核心1】加锁：防止重复执行（彻底解决多实例冲突）
				if (that.isWebRTCStarting) return;
				that.isWebRTCStarting = true;

				// 【核心2】彻底清理所有旧资源 + 定时器
				that.stopWebRTC();
				clearTimeout(that.webrtcTimeoutTimer);
				clearTimeout(that.rtcTimer);

				let app = '', stream = '';
				try {
					if (url.includes('webrtc://')) {
						let tmp = url.replace('webrtc://', '')
						let parts = tmp.split('/')
						if (parts.length >= 3) {
							app = parts[1]
							stream = parts[2]
						}
					} else {
						const urlObj = new URL(url)
						app = urlObj.searchParams.get('app') || ''
						stream = urlObj.searchParams.get('stream') || ''
					}
					if (!app || !stream) throw new Error('无法解析 app/stream')
				} catch (e) {
					console.error('❌[WebRTC] 解析 URL 失败:', e)
					that.ifWaiting = false
					that.$emit('playStop', 'stop')
					that.isWebRTCStarting = false; // 解锁
					return
				}

				const maxWaitTime = 3000;
				const startTime = Date.now();
				const waitForContainer = () => {
					const container = that.$refs.playerRef;
					if (Date.now() - startTime > maxWaitTime) {
						console.error('❌[WebRTC] 播放器容器获取超时');
						that.ifWaiting = false;
						that.$emit('playStop', 'stop');
						that.isWebRTCStarting = false; // 解锁
						return;
					}
					if (!container) {
						console.warn('⏳ 等待播放器容器渲染...');
						setTimeout(waitForContainer, 100);
						return;
					}
					doStartWebRTC(container);
				};
				waitForContainer();

				async function doStartWebRTC(container) {
					container.innerHTML = '';
					const videoEl = document.createElement('video');
					videoEl.autoplay = true;
					videoEl.muted = true;
					videoEl.playsInline = true;
					videoEl.controls = false;
					videoEl.style.width = '100%';
					videoEl.style.height = '100%';
					videoEl.style.objectFit = 'contain';
					container.appendChild(videoEl);
					that.webrtcVideoElement = videoEl;

					const pc = new RTCPeerConnection(ICE_CONFIG);
					that.peerConnection = pc;

					// ========== 【核心3】优化状态监听：断开后允许重连 ==========
					pc.oniceconnectionstatechange = () => {
						const state = pc.iceConnectionState;
						console.log('🧊 ICE 连接状态:', state);

						if (state === 'connected') {
							that.isWebRTCConnected = true;
						}
						if (state === 'disconnected' || state === 'failed' || state === 'closed') {
							that.isWebRTCConnected = false;
						}
						if (state === 'failed' || state === 'closed') {
							console.error('❌[WebRTC] ICE连接失败，重试...');
							that.isWebRTCStarting = false;
							setTimeout(() => that.startWebRTC(url), 2000);
						}
					};

					pc.onconnectionstatechange = () => {
						const state = pc.connectionState;
						console.log('🔗 连接总状态:', state);
						if (state === 'connected') {
							that.isWebRTCConnected = true;
						}
						if (state === 'disconnected' || state === 'failed') {
							that.isWebRTCConnected = false;
						}
						if (state === 'failed') {
							that.isWebRTCStarting = false;
							setTimeout(() => that.startWebRTC(url), 2000);
						}
					};

					pc.onicegatheringstatechange = () => {
						console.log('📡 ICE 候选收集:', pc.iceGatheringState);
					};

					pc.addTransceiver('video', { direction: 'recvonly' });

					// ========== 【核心5】流事件：确保流一定绑定到video ==========
					let streamAttached = false;
					pc.ontrack = (event) => {
						console.log('✅[WebRTC] 收到视频流', event.streams[0]);
						
						// 【修复】无论连接状态如何，都先确保流绑定到video元素
						if (!streamAttached && event.streams && event.streams[0]) {
							streamAttached = true;
							videoEl.srcObject = event.streams[0];
							videoEl.play().catch(err => {
								console.warn('⚠️ 视频自动播放失败:', err);
							});
							console.log('✅[WebRTC] 流已绑定到video元素');
						}

						if (that.isWebRTCConnected) return; // 状态标记只需执行一次
						
						clearTimeout(that.webrtcTimeoutTimer);
						that.ifWaiting = false;
						that.ifPlayStop = false;
						that.isWebRTCConnected = true; // 标记成功
						that.$emit('playStop', 'play');
						that.isWebRTCStarting = false; // 解锁
					};

					try {
						const offer = await pc.createOffer({ offerToReceiveVideo: true });
						await pc.setLocalDescription(offer);
						const res = await getWebrtcPlay({ app, stream, sdp: offer.sdp });
						if (res.data.sdp) {
							const answer = new RTCSessionDescription({ 
								type: 'answer', 
								sdp: res.data.sdp 
							});
							await pc.setRemoteDescription(answer);
						} else {
							throw new Error('后端未返回SDP');
						}
					} catch (e) {
						console.error('❌[WebRTC] 信令交互失败:', e);
						that.ifWaiting = false;
						that.isWebRTCStarting = false;
						setTimeout(() => that.startWebRTC(url), 2000);
						return;
					}

					that.webrtcTimeoutTimer = setTimeout(() => {
						if (!that.isWebRTCConnected) {
							console.error('❌[WebRTC] 10秒未收到视频流，重试');
							that.isWebRTCStarting = false;
							that.startWebRTC(url);
						}
					}, 10000);

					that.ifWaiting = false;
				}
			},

			// ========== 【修复】停止方法：重置所有状态 ==========
			stopWebRTC() {
				const that = this;
				clearTimeout(that.webrtcTimeoutTimer);
				clearTimeout(that.rtcTimer);
				
				// 重置状态标记
				that.isWebRTCStarting = false;
				that.isWebRTCConnected = false;
				
				if (that.peerConnection) {
					that.peerConnection.close();
					that.peerConnection = null;
				}
				if (that.webrtcVideoElement) {
					that.webrtcVideoElement.pause();
					that.webrtcVideoElement.srcObject = null;
					that.webrtcVideoElement.remove();
					that.webrtcVideoElement = null;
				}
				const container = that.$refs.playerRef;
				if (container) container.innerHTML = '';
			},

			// ============== 以下所有原有逻辑 100% 保留，无修改 ==============
			clickPlay() {
				let that = this
				try {
					if (that.ifRtc) {
						if (that.peerConnection && that.webrtcVideoElement) {
							that.webrtcVideoElement.play().catch(e => console.warn)
						} else if (that.playerRtc) {
							that.playerRtc.play(that.flvUrl, that.$refs.playerRef)
						}
					} else if (that.isM3u8 && that.videoPlayer) {
						that.videoPlayer.play()
					} else if (that.isM3u8 && that.hlsPlayer) {
						const videoElement = that.$refs.m3u8PlayerRef && that.$refs.m3u8PlayerRef.querySelector('video')
						if (videoElement) videoElement.play()
					}
				} catch (e) {}
				
				that.ifPlayStop = false
				that.playAudoStatus = "play"
				that.$emit('playStop', 'play')
				
				if (that.nextInitialNO) { that.$emit('closeFlv', true) }
				
				if (that.ststus == '0') {
					that.setTimeNum = 1
					if (that.setTimeFlv) clearInterval(that.setTimeFlv)
					that.setTimeFlv = setInterval(() => {
						if (that.setTimeNum >= that.countTime) {
							clearInterval(that.setTimeFlv)
							that.setTimeFlv = null
							that.setTimeNum = 0
							if (that.oldSocket.videoStatus == '1') {
								setTimeout(() => {
									try {
										if (that.ifRtc) {
											if (that.peerConnection) that.peerConnection.close()
											if (that.webrtcVideoElement) that.webrtcVideoElement.pause()
											if (that.playerRtc) that.playerRtc.stop()
										} else if (that.isM3u8 && that.videoPlayer) { that.videoPlayer.pause() }
										else if (that.isM3u8 && that.hlsPlayer) {
											const videoElement = that.$refs.m3u8PlayerRef.querySelector('video')
											if (videoElement) videoElement.pause()
										}
									} catch (e) {}
									that.ifPlayStop = true
									that.ifWaiting = false
									that.$emit('playStop', 'stop')
								}, 1000)
							}
						} else { that.setTimeNum += 1 }
					}, 1000)
				}
			},
			changePlayFly() {
				let that = this
				try {
					if (that.ifRtc) {
						if (that.peerConnection && that.webrtcVideoElement) { that.webrtcVideoElement.play().catch(e => console.warn) }
						else if (that.playerRtc) { that.playerRtc.play(that.flvUrl, that.$refs.playerRef) }
					} else if (that.isM3u8 && that.videoPlayer) { that.videoPlayer.play() }
					else if (that.isM3u8 && that.hlsPlayer) {
						const videoElement = that.$refs.m3u8PlayerRef.querySelector('video')
						if (videoElement) videoElement.play()
					}
				} catch (e) {}
				that.ifPlayStop = false
				that.$emit('playStop', 'play')
			},
			videoPlay(url) {
				let that = this
				if (that.playerRtc) { try { that.playerRtc.stop(); that.playerRtc.release() } catch(e) {}; that.playerRtc = null }

				const tryPlay = () => {
					const playerDom = that.$refs.playerRef
					if (!playerDom) { setTimeout(tryPlay, 100); return }

					that.playerRtc = new QNRTPlayer()
					that.ifWaiting = true

					that.playerRtc.on('playerStateChanged', state => {
						console.log('✅ WebRTC状态:', state)
						if (state === 3) {
							that.ifWaiting = false
							that.ifPlayStop = false
						} else if (state === 5) {
							console.error('❌ 播放失败，1秒后重试')
							that.ifWaiting = false
							setTimeout(() => that.videoPlay(url), 1000)
						}
					})

					try {
						that.playerRtc.init({ 
							volumn: null, 
							controls: false,
							iceServers: ICE_CONFIG.iceServers,
							timeout: 15000
						})
						that.playerRtc.play(url, playerDom)
					} catch (e) {
						console.error('❌ WebRTC执行报错:', e)
						that.ifWaiting = false
					}
				}
				this.$nextTick(() => tryPlay())
			},
			initM3u8Player(url) {
				let that = this
				that.ifWaiting = true
				try {
					const videoElement = document.createElement('video-js')
					videoElement.id = `video-${Date.now()}`
					videoElement.className = 'video-js vjs-default-skin vjs-big-play-centered'
					videoElement.style.width = '100%'
					videoElement.style.height = '100%'
					
					const container = that.$refs.m3u8PlayerRef
					if (container) {
						container.innerHTML = ''
						container.appendChild(videoElement)
						that.videoPlayer = videojs(videoElement.id, {
							controls: false, autoplay: true, preload: 'auto', muted: true,
							sources: [{ src: url, type: 'application/x-mpegURL' }],
							html5: { hls: { enableLowInitialPlaylist: true, smoothQualityChange: true } }
						})
						that.videoPlayer.ready(() => {
							that.ifWaiting = false
							that.videoPlayer.on('playing', () => { that.ifPlayStop = false; that.$emit('playStop', 'play') })
							that.videoPlayer.on('pause', () => { that.ifPlayStop = true; that.$emit('playStop', 'stop') })
						})
						that.videoPlayer.on('error', () => {
							console.error('M3U8 播放错误')
							that.ifWaiting = false
							that.playHlsNative(url)
						})
					}
				} catch (error) {
					console.error('初始化 video.js 失败:', error)
					that.ifWaiting = false
					that.playHlsNative(url)
				}
			},
			playHlsNative(url) {
				let that = this
				const container = that.$refs.m3u8PlayerRef
				if (!container) return
				container.innerHTML = ''
				const videoElement = document.createElement('video')
				videoElement.style.width = '100%'
				videoElement.style.height = '100%'
				videoElement.controls = false
				videoElement.autoplay = true
				videoElement.muted = true
				videoElement.playsInline = true
				container.appendChild(videoElement)
				
				if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
					videoElement.src = url
					that.ifWaiting = false
				} else if (Hls.isSupported()) {
					that.hlsPlayer = new Hls({ enableWorker: false, lowLatencyMode: true })
					that.hlsPlayer.loadSource(url)
					that.hlsPlayer.attachMedia(videoElement)
					that.hlsPlayer.on(Hls.Events.MANIFEST_PARSED, () => { that.ifWaiting = false })
					that.hlsPlayer.on(Hls.Events.ERROR, (event, data) => {
						console.error('HLS 播放错误:', data)
						if (data.fatal) { that.hlsPlayer.startLoad() }
					})
				} else {
					that.isM3u8 = false
					that.flvPlayerSrc = 'https://player.xstrive.com/video/live?videoUrl=' + decodeURI(url) + '&isLive=1&isMute=1'
				}
			},
			stopM3u8Player() {
				let that = this
				if (that.videoPlayer) { that.videoPlayer.dispose(); that.videoPlayer = null }
				if (that.hlsPlayer) { that.hlsPlayer.destroy(); that.hlsPlayer = null }
				if (that.$refs.m3u8PlayerRef) { that.$refs.m3u8PlayerRef.innerHTML = '' }
			}
		},
		watch: {
			// 新增：监听isStart状态，开启后立即执行WebRTC
			isStart(newVal) {
				// 只有开启isStart + 有视频地址 + 未播放 → 执行
				if (newVal && this.rtmpSrc && !this.isWebRTCConnected) {
				this.startWebRTC(this.rtmpSrc);
				}
			},
			'rtmpSrc': { immediate: true, deep: true, handler(newValue) {
				let that = this
				// 【核心】每次切换地址，先清理定时器
				clearTimeout(that.rtcTimer);
				this.ifSignal = newValue ? false : true
				if (that.$refs.flvIframe) that.$refs.flvIframe.src = ''
				if (newValue) {
					const isM3u8Format = newValue.includes('.m3u8') || newValue.includes('/hls/') || newValue.endsWith('.m3u8')
					if (that.private && !isM3u8Format) {
						this.ifRtc = true; this.isM3u8 = false; this.stopM3u8Player()
						if (this.playerRtc) { try { this.playerRtc.stop(); this.playerRtc.release() } catch(e) {}; this.playerRtc = null }
						this.stopWebRTC()
						this.rtcTimer = setTimeout(() => {
							this.startWebRTC(newValue).catch(err => {
								console.error('WebRTC 播放失败:', err)
								this.ifWaiting = false
								this.$emit('playStop', 'stop')
							})
						}, 300)
					} else if ((that.private && isM3u8Format) || (config && config.hkM3u8Url && isM3u8Format)) {
						this.ifRtc = false; this.isM3u8 = true; if (this.playerRtc) { this.playerRtc.release(); this.playerRtc = null }
						this.stopWebRTC(); this.stopM3u8Player()
						setTimeout(() => { this.ifWaiting = true; this.initM3u8Player(newValue) }, 100)
					}else if (newValue.indexOf("qvs-live") !== -1 && newValue.indexOf("webrtc") !== -1) {
					// ⭐ 七牛云视频流 → 走 QNRTPlayer SDK
					console.log('✅✅✅----七牛云SDK播放--------', newValue)
					this.ifRtc = true; this.isM3u8 = false; this.stopM3u8Player(); this.stopWebRTC()
					if (this.rtcTimer) { clearTimeout(this.rtcTimer); this.rtcTimer = null }
					if (this.playerRtc) { try { this.playerRtc.stop(); this.playerRtc.release() } catch(e) {}; this.playerRtc = null }
					this.rtcTimer = setTimeout(() => {
						this.ifWaiting = true
						this.flvUrl = newValue
						this.videoPlay(newValue)
					}, 300)
					} else if (newValue.indexOf("webrtc") !== -1) {
						// 非七牛云 WebRTC（自建信令）
						console.log('✅✅✅----原生WebRTC播放--------',newValue)
						this.ifRtc = true; this.isM3u8 = false; this.stopM3u8Player(); this.stopWebRTC()
						if (this.playerRtc) { this.playerRtc.stop(); this.playerRtc.release() }
						this.rtcTimer = setTimeout(() => {
							this.startWebRTC(newValue).catch(err => {
								console.error('原生WebRTC播放失败:', err);
								this.ifWaiting = false;
								this.$emit('playStop', 'stop');
							});
						}, 300)
					} else {
						this.ifRtc = false; this.isM3u8 = false; this.stopM3u8Player(); this.stopWebRTC()
						this.flvPlayerSrc = 'https://player.xstrive.com/video/live?videoUrl=' + decodeURI(newValue) + '&isLive=1&isMute=1'
					}
				} else { this.flvPlayerSrc = '' }
			}},
			'playStatus': { immediate: true, handler(newValue, oldValue) {
				if (oldValue === undefined) return
				if (!newValue) {
					setTimeout(() => {
						try {
							if (this.ifRtc) {
								if (this.peerConnection) this.peerConnection.close();
								if (this.webrtcVideoElement) this.webrtcVideoElement.pause();
								if (this.playerRtc) { try { this.playerRtc.stop() } catch(e) {} }
							}
							else if (this.playerRtc) { this.playerRtc.stop() }
							else if (this.isM3u8 && this.$refs.m3u8PlayerRef) { const video = this.$refs.m3u8PlayerRef.querySelector('video'); if (video) video.pause() }
						} catch (e) {}
						this.ifWaiting = false; this.ifPlayStop = true
					}, 500)
				} else { setTimeout(() => this.clickPlay(), 100) }
			}},
			'playAudo': { immediate: true, handler(newValue) {
				if (newValue == 'stop') {
					this.playAudoStatus = newValue
					let setTimeInter = setInterval(() => {
						try {
							if (this.ifRtc && this.playerRtc) { this.playerRtc.stop() }
							else if (this.isM3u8 && this.videoPlayer) { this.videoPlayer.pause() }
							else if (this.isM3u8 && this.hlsPlayer) {
								const videoElement = this.$refs.m3u8PlayerRef.querySelector('video')
								if (videoElement) videoElement.pause()
							}
						} catch (e) {}
						this.ifWaiting = false; this.ifPlayStop = true; clearInterval(setTimeInter)
					}, 1000)
				} else if (newValue == 'play') { this.playAudoStatus = newValue }
			}},
			'vSocketData': { immediate: true, deep: true, handler(newValue) {
				if (newValue && newValue.socketType == '1' && newValue.robotId == this.rid) {
					if (newValue.videoStatus != this.oldSocket.videoStatus) {
						this.oldSocket = newValue
						if(this.ststus == '0') {
							if (this.setTimeNum < 8 && this.playAudoStatus != 'stop') {
								if (newValue.videoStatus == '1') {
									setTimeout(() => {
										try {
											if (this.ifRtc && this.playerRtc) { this.playerRtc.stop() }
											else if (this.isM3u8 && this.videoPlayer) { this.videoPlayer.pause() }
											else if (this.isM3u8 && this.hlsPlayer) { const videoElement = this.$refs.m3u8PlayerRef.querySelector('video'); if (videoElement) videoElement.pause() }
										} catch (e) {}
										this.ifPlayStop = true; this.ifWaiting = false; this.$emit('playStop', 'stop')
									}, 200)
								} else if (newValue.videoStatus == '0') { this.changePlayFly() }
							}
						} else {
							if (this.setTimeNum == 0 && this.playAudoStatus != 'stop') {
								if (newValue.videoStatus == '1') {
									setTimeout(() => {
										try {
											if (this.ifRtc && this.playerRtc) { this.playerRtc.stop() }
											else if (this.isM3u8 && this.videoPlayer) { this.videoPlayer.pause() }
											else if (this.isM3u8 && this.hlsPlayer) { const videoElement = this.$refs.m3u8PlayerRef.querySelector('video'); if (videoElement) videoElement.pause() }
										} catch (e) {}
										this.ifPlayStop = true; this.ifWaiting = false; this.$emit('playStop', 'stop')
									}, 200)
								} else if (newValue.videoStatus == '0') { this.changePlayFly() }
							}
						}
					}
				}
			}}
		},
		beforeDestroy() {
			if (this.$refs.flvIframe) this.$refs.flvIframe.src = ''
			this.flvPlayerSrc = ''
			if (this.playerRtc) { try { this.playerRtc.stop(); this.playerRtc.release() } catch(e) {}; this.playerRtc = null }
			this.stopWebRTC()
			this.stopM3u8Player()
			clearInterval(this.setTimeFlv)
			clearTimeout(this.rtcTimer)
			clearTimeout(this.webrtcTimeoutTimer)
		}
	}
</script>
<style scoped>
	.initialNewClass { position: absolute; width: 25%; top: 30%; left: 35%; z-index: 99; cursor: pointer; }
	.video { pointer-events: none; }
	.video-js { width: 100%; height: 100%; }
</style>


// WEBPACK FOOTER //
// src/components/flv264V3.vue